type AxiosLikeError = {
    response?: {
        data?: {
            message?: string
            error?: string
        }
    }
    message?: string
}

export const parseAxiosError = (error: unknown, fallbackMessage = 'Something went wrong') => {
    const axiosError = error as AxiosLikeError
    return axiosError?.response?.data?.message || axiosError?.response?.data?.error || axiosError?.message || fallbackMessage
}
